import * as Inovx from '@shared';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/HierarchyItem`;

interface IHierarchyItemDetailApiData extends INamedItem {
    ItemType: number;
    ItemClassName: string;
    Parents: IHierarchyItemNameDetailApiData[];
    InternalAttributes: IHierarchyItemAttributeValueApiData[];
}

interface IHierarchyItemNameDetailApiData extends INamedItem {
    HasAttributes: boolean;
    ItemClassName: string;
}

interface IHierarchyItemAttributeValueApiData {
    SetDefinitionName: string;
    Name: string;
    Value: string;
    Unit: string;
    IsUrl: boolean;
}

const HierarchyItemServices = { ...Inovx.Shared.Flux.BaseService,

    getHierarchyItemDetail: function (id: string) {
        return new Promise<IHierarchyItemDetailApiData>((resolve, reject) => {
            this.get(`${url}/Detail`,
                { id } ,
                (retData: IHierarchyItemDetailApiData) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getChildNames: function (id: string) {
        return new Promise<INamedItem[]>((resolve, reject) => {
            this.get(`${url}/ChildNames`,
                { id },
                (retData: INamedItem[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getAssetObjectIds: function (parentAssetId: string) {
        return new Promise<string[]>((resolve, reject) => {
            this.get(`${url}/AssetObjectChildren`,
                { id: parentAssetId },
                (retData: string[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },

    getAssetExtent: function (assetObjectId: string) {
        return new Promise<IExtents>((resolve, reject) => {
            this.get(`${url}/AssetExtent`,
                { id: assetObjectId },
                (retData: IExtents) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    }

};

export default HierarchyItemServices;